import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import { Suspense } from 'react';
import { useRepositoryDataConfig } from './RepositoryDataGrid.config';

const RepositoryDataGrid = () => {
  const { config, data, loading } = useRepositoryDataConfig();
  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};
export default RepositoryDataGrid;
